<template>
    <div class="pt-8">
        <template >
            <b-card no-body >
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="info">
                        <b-icon icon="search" aria-hidden="true"></b-icon>
                        Filtro de busqueda
                    </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <b-row>        
                                <b-col cols="12" md="4">
                                    <label for="ventaId">Identificador</label>
                                    <b-form-input id="ventaId" v-model="ventaId" @keydown.enter.prevent="getVentas" placeholder="Identificador"></b-form-input>
                                </b-col>                    
                                <b-col cols="12" md="4">
                                    <label for="vendedor">Vendedor</label>
                                    <b-form-input id="vendedor" v-model="vendedor" @keydown.enter.prevent="getVentas" placeholder="vendedor"></b-form-input>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="cliente">Nombre cliente</label>
                                    <b-form-input id="cliente" v-model="cliente" @keydown.enter.prevent="getVentas" placeholder="Nombre cliente"></b-form-input>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="nit">Nit Cliente</label>
                                    <b-form-input id="nit" v-model="nit" @keydown.enter.prevent="getVentas" placeholder="Nit Cliente"></b-form-input>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="departamento">Departamento</label>
                                     <b-form-group>
                                            
                                        <b-form-select
                                        v-model="departamento"
                                        :options="departamentos_list"
                                        id="departamento"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        @change="getCiudadesList()"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                    </b-form-group>
                                    <!--
                                    <b-form-input id="departamento" v-model="departamento" @keydown.enter.prevent="getVentas" placeholder="Departamento"></b-form-input>
                                    -->
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="ciudad">Ciudad</label>
                                    <b-form-group>
                                            
                                        <b-form-select
                                        v-model="ciudad"
                                        :options="ciudades_list"
                                        id="ciudad"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                    </b-form-group>
                                    <!--
                                    <b-form-input id="ciudad" v-model="ciudad" @keydown.enter.prevent="getVentas" placeholder="Ciudad"></b-form-input>
                                    -->
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="forma_pago">Forma de pago</label>
                                     <b-form-group>
                                            
                                        <b-form-select
                                        v-model="forma_pago"
                                        :options="forma_pago_list"
                                        id="forma_pago"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        >
                                        <template #first>
                                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                    </b-form-group>
                                    <!--
                                    <b-form-input id="departamento" v-model="departamento" @keydown.enter.prevent="getVentas" placeholder="Departamento"></b-form-input>
                                    -->
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="date-from">Desde</label>
                                    <b-form-datepicker placeholder="Seleccione Desde" id="date-from" v-model="dateFrom"></b-form-datepicker>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="date-to">Hasta</label>
                                    <b-form-datepicker id="date-to" v-model="dateTo"></b-form-datepicker>
                                </b-col>
                                <b-col cols="12" md="12">
                                    <div >
                                        <b-button variant="info" @click.prevent="getVentas" class="mx-1">
                                            <b-icon icon="search" aria-hidden="true"></b-icon>
                                            Buscar
                                        </b-button>
                                        <b-button variant="warning" @click.prevent="clearSearchForm" class="mx-1 text-white">
                                            <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                            Limpiar
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </template>
        <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0" style="font-size: 21px">Listado de Venta Rápida PTV</p>
            </template>
            <b-row>          
                <b-col cols="12" md="12">
                    <div class="text-right">
                        <b-button variant="info" class="text-white mr-2" :to="{name: 'ListadoVentasTotales'}">Ventas Totales</b-button>
                        <b-button variant="info" class="text-white" :to="{name: 'RealizarVenta'}">Ventas en Curso</b-button>
                    </div>
                </b-col>
            </b-row>
            <b-card-text>
                <b-table 
                    responsive
                    :fields="fields" 
                    striped hover 
                    :items="ventas">
                    <template v-slot:cell(id)="data">
                        {{ data.item.id }}
                    </template>
                    <template v-slot:cell(nombre_usuario)="data">
                        {{ data.item.nombre_usuario }}
                    </template>
                    <template v-slot:cell(created_at)="data">
                        {{ data.item.created_at }}
                    </template>
                    <template v-slot:cell(cliente_nombre)="data">
                        {{ data.item.cliente_nombre }}
                    </template>
                    <template v-slot:cell(cliente_nit)="data">
                        {{ data.item.cliente_nit }}
                    </template>
                    <template v-slot:cell(nombre_departamento_venta)="data">
                        {{ data.item.nombre_departamento_venta }}
                    </template>
                    <template v-slot:cell(nombre_ciudad_venta)="data">
                        {{ data.item.nombre_ciudad_venta }}
                    </template>
                    <template v-slot:cell(monto_total)="data">
                        $ {{numberFormat(data.item.monto_total) }}
                    </template>
                    <template v-slot:cell(metodo_pago)="data">
                        
                        <span v-if="data.item.metodo_pago == 1"> Efectivo</span>
                        <span v-else-if="data.item.metodo_pago == 2"> Tarjeta</span>
                        <span v-else-if="data.item.metodo_pago == 3"> Crédito</span>
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <b-button variant="info" v-b-tooltip.hover title="Ver" class="text-white mr-2" 
                        :to="{name: 'InfoVenta', params:{ id: item.id}}">
                            <b-icon icon="search"></b-icon>
                        </b-button>
                    
                        <b-button variant="info" v-b-tooltip.hover title="imprimir" class="text-white" 
                        :to="{name: 'printVenta', params:{ id: item.id}}" target="_blank">
                            <b-icon icon="card-heading"></b-icon>
                        </b-button>
                    </template>
                </b-table>
                <template v-if="ventas.length < 1">
                    <b-alert show variant="danger">
                        Lo sentimos, no se han encontrado resultados para su busqueda.
                    </b-alert>
                </template>
            </b-card-text>
            <template v-slot:footer>
                <div class="mt-3">
                    <b-row>                            
                        <b-col cols="12" md="4">
                            <b-pagination 
                                size="md" 
                                pills 
                                :total-rows="paginator.totalPage" 
                                v-model="paginator.page" 
                                :per-page="1" 
                                @input="changePage" 
                                first-number 
                                last-number>
                            </b-pagination>
                        </b-col>
                        <b-col cols="12" sm="2">
                            <b-form-select @change="getVentas" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </b-card>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            ventas: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            ventaId: "",
            vendedor: "",
            cliente: "",
            nit: "",
            departamento: "",
            ciudad: "",
            dateFrom: "",
            dateTo: new Date().toISOString().substr(0, 10),
            fields: [
                { key: 'id', label: '#', sortable: true},
                { key: 'nombre_usuario', label: 'Realizado Por', sortable: true},
                { key: 'created_at', label: 'Fecha', sortable: true},
                { key: 'cliente_nombre', label: 'Cliente', sortable: true},
                { key: 'cliente_nit', label: 'Nit', sortable: true},
                { key: 'nombre_departamento_venta', label: 'Depto', sortable: true},
                { key: 'nombre_ciudad_venta', label: 'Ciudad', sortable: true},
                { key: 'monto_total', label: 'Precio Total', sortable: true},
                { key: 'metodo_pago', label: 'Forma de pago', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
            departamentos_list: [],
            ciudades_list: [],
            forma_pago_list: [
                {id: 1, nombre: 'Efectivo'},
                {id: 2, nombre: 'Tarjeta'},
                {id: 3, nombre: 'Crédito'},
            ],
            forma_pago: "",
        }
    },
    created(){
        this.getVentas();
        this.getDepartamentosList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getVentas() {
            this.pageOptions = { 
                pageNumber:   this.paginator.page, 
                pageSize:     this.paginator.pageSize,
                ventaId:      this.ventaId,
                vendedor:     this.vendedor,
                cliente:      this.cliente,
                nit:          this.nit,
                departamento: this.departamento,
                ciudad:       this.ciudad,
                forma_pago:   this.forma_pago,
                dateFrom:     this.dateFrom,
                dateTo:       this.dateTo,
            }
            this.setLoading(true)
            await this.$conectar.post('punto-venta/get-ventas-list', this.pageOptions)
            .then(response =>{
                this.ventas = response.data.ventasLists;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentos_list = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            if(this.departamento != ''){
                this.ciudad = "";
                this.departamentoSelected = { 
                    departamento_id:   this.departamento, 
                }
                this.setLoading(true)
                await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
                .then(response =>{
                    this.ciudades_list = response.data.ciudadesList;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.setLoading(false)
            }else{
                this.ciudades_list = [];
            }
        },
        changePage(page){
            this.paginator.page = page;
            this.getVentas();
        },
        clearSearchForm(){
            this.ventaId = "";
            this.vendedor = "";
            this.cliente = "";
            this.nit = "";
            this.departamento = "";
            this.ciudad = "";
            this.dateFrom = "";
            this.dateTo = new Date().toISOString().substr(0, 10);
            this.paginator.pageSize = 10;
        },
    }
}
</script>

<style scoped>
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.singleLineTd td {
  white-space: nowrap !important;
  overflow: hidden !important;
}
</style>